var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.16994 6.99999C8.98369 7.18735 8.87915 7.4408 8.87915 7.70499C8.87915 7.96918 8.98369 8.22263 9.16994 8.40999L12.7099 12L9.16994 15.54C8.98369 15.7274 8.87915 15.9808 8.87915 16.245C8.87915 16.5092 8.98369 16.7626 9.16994 16.95C9.26291 17.0437 9.37351 17.1181 9.49537 17.1689C9.61723 17.2197 9.74793 17.2458 9.87994 17.2458C10.012 17.2458 10.1427 17.2197 10.2645 17.1689C10.3864 17.1181 10.497 17.0437 10.5899 16.95L14.8299 12.71C14.9237 12.617 14.9981 12.5064 15.0488 12.3846C15.0996 12.2627 15.1257 12.132 15.1257 12C15.1257 11.868 15.0996 11.7373 15.0488 11.6154C14.9981 11.4936 14.9237 11.383 14.8299 11.29L10.5899 6.99999C10.497 6.90626 10.3864 6.83187 10.2645 6.7811C10.1427 6.73033 10.012 6.70419 9.87994 6.70419C9.74793 6.70419 9.61723 6.73033 9.49537 6.7811C9.37351 6.83187 9.26291 6.90626 9.16994 6.99999Z",
    fill: "#939598"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.f175509ec7b3de461d64eef41ca66fb3.svg";
export { ForwardRef as ReactComponent };